import React from 'react';

export const CTA: React.FC = () => {
  return (
    <section className="cta">
      <div className="container">
        <h2>Quiet roads are about to get a lot less lonely.</h2>
        <p>
          RoadStatic is in early access. Get in touch to spin up a channel for
          your fleet or convoy group.
        </p>
        <a className="btn btn-primary" href="mailto:hello@roadstatic.app">
          Request access
        </a>
      </div>
    </section>
  );
};
